import { Anchor, Paper, SimpleGrid, Stack, Text } from "@mantine/core"
import { IconFileText, IconMail, IconReceipt2, IconUsers } from "@tabler/icons-react"
import { createFileRoute, useNavigate } from "@tanstack/react-router"

const HUB_SECTIONS = [
  {
    label: "Documents",
    description: "Subscription agreements, fund formation, LP communications.",
    path: "/hub/documents",
    Icon: IconFileText,
  },
  {
    label: "IC Meetings",
    description: "Investment committee minutes, voting records, agendas.",
    path: "/hub/ic-meetings",
    Icon: IconUsers,
  },
  {
    label: "Communications",
    description: "Quarterly LP letters, capital call notices, distribution notices.",
    path: "/hub/communications",
    Icon: IconMail,
  },
  {
    label: "Tax Documents",
    description: "K-1s, QSBS attestations, state tax filings.",
    path: "/hub/tax-documents",
    Icon: IconReceipt2,
  },
] as const

export const Route = createFileRoute("/hub/")({
  component: HubIndex,
})

function HubIndex() {
  const navigate = useNavigate()

  return (
    <Stack gap="md">
      <Text fz={14} lh={1.6} c="var(--pitch-text-secondary)" maw={680}>
        Corporate records and LP correspondence for Civala Bio Syndicate I.
      </Text>
      <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="md">
        {HUB_SECTIONS.map(({ label, description, path, Icon }) => (
          <Paper
            key={path}
            withBorder
            p="lg"
            radius={0}
            style={{ cursor: "pointer", borderColor: "var(--pitch-border)" }}
            onClick={() => void navigate({ to: path })}
          >
            <Stack gap="xs">
              <Icon size={22} stroke={1.5} color="var(--pitch-accent)" />
              <Text fw={600} fz={16} c="var(--pitch-text-primary)">
                {label}
              </Text>
              <Text fz={13} lh={1.5} c="var(--pitch-text-secondary)">
                {description}
              </Text>
              <Anchor fz={12} c="var(--pitch-accent)" onClick={() => void navigate({ to: path })}>
                Open →
              </Anchor>
            </Stack>
          </Paper>
        ))}
      </SimpleGrid>
    </Stack>
  )
}
